import { Box, Tooltip } from '@mui/material';
import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../../../../../libs/Context';
import NoQRShareMenu from '../../../../../../UiComponents/ShareScreen/NoQrShare';
import useGetFeedPermissions from '../../../CustomHooks/useGetFeedPermissions';
import { useSelector } from 'react-redux';

interface Props {
	feedId: string;
	feed: any;
}
const ShareButton = (props: Props) =>
{
	const { feedId, feed } = props;
	const { language } = useContext(LanguageContext);
	const [ anchorEl, setAnchorEl ] = useState(null);
	const sharepostUrl = `${process.env.REACT_APP_SHAREURL_FEED}${window.btoa(feedId)}`;
	// const { feedManagement } = useSelector((state:any) => state.mysession.configs);
	// const enableShare = feedManagement?.feedsConfig?.share;
	const socialMediaIcons = [
		{ key: 'facebook', imgUrl: '/images/icons/facebook.svg', urlTemplate: 'https://www.facebook.com/sharer/sharer.php?u='	},
		// { key: 'linkedin', imgUrl: '/images/icons/linkedIn.svg', urlTemplate: 'https://www.linkedin.com/shareArticle?mini=true&url=' },
		{ key: 'twitter', imgUrl: '/images/icons/twitter.svg', urlTemplate: 'https://twitter.com/intent/tweet?url=' }
	];
	const userData = useSelector((state:any) => state.mysession.session);
	const getPermission = useGetFeedPermissions(feed, userData);

	const disabled = [ 'poll' ].includes(feed?.feedType) || !getPermission('share');

	if (disabled) return <></>;

	const handleClick = (event) =>
	{
		if (!disabled) setAnchorEl(event.currentTarget);
	};

	const handleClose = () =>
	{
		setAnchorEl(null);
	};

	return (
		<>
			<Tooltip title={language.share} placement='top'>
				<Box
					component='img'
					src='/images/icons/Images/share.svg'
					alt='Icon'
					height={'var(--pixel18)'}
					width={'var(--pixel18)'}
					sx={{ cursor    : 'pointer',
						...(disabled ? { opacity: 0.3, pointerEvents: 'none' } : {}),
						'&:hover' : {
							filter    : 'invert(49%) sepia(98%) saturate(365%) hue-rotate(145deg) brightness(93%) contrast(92%)',
							transform : 'scale(1.2)'
						} }}
					onClick={handleClick}
				/>
			</Tooltip>
			<NoQRShareMenu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				handleClose={handleClose}
				link={sharepostUrl}
				title={language.shareLink}
				socialMediaIcons={socialMediaIcons}
			/>
		</>
	);
};

export default ShareButton;